import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Signup } from '@/components/Signup';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/signup')({
  component: SignupPage,
});

function SignupPage() {
  const { isAuthenticated, isInitializing, checkAuth } = useAuthStore();

  useEffect(() => {
    if (isInitializing) {
      checkAuth();
    }
  }, [checkAuth, isInitializing]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <Signup />;
}

